import { useEffect, useState }   from 'react'
import { ratingActivityService } from "../services";
import { useLocation }           from "react-router";
import { setAlertNotification }  from "../actions/util";
import { useDefaultLimit }       from "./WindowUtil";

export const useRatingActivityList = (props) => {

  const {defaultLimit} = useDefaultLimit()
  const {ratingId} = props || {};
  const location = useLocation();
  let param = new URLSearchParams(location.search);
  const ratingParamId = param.get("rating");

  const [ratingActivities, setRatingActivities] = useState([]);
  const [pagination, setPagination] = useState({limit: defaultLimit, skip: 0, filterName: "", columnSort: "ActivityDate", descending: true});

  const getRatingActivities = (limit = pagination.limit, skip = pagination.skip, filterName = pagination.filterName, columnSort = pagination.columnSort, descending = pagination.descending) => {
    if (ratingId || ratingParamId) {
      ratingActivityService()
        .getRatingActivities(ratingId || ratingParamId, limit, skip, filterName, columnSort, descending)
        .then(res => {
          if (res && res.data) {
            setRatingActivities(res.data);
            setPagination({
              ...pagination,
              count: parseInt(res.headers['x-total-count'], 10),
              limit: parseInt(res.headers['x-total-limit'], 10),
              skip: parseInt(res.headers['x-total-skip'], 10),
              columnSort,
              descending
            })
          }
        })
    }
  };

  useEffect(() => {
    getRatingActivities()
    // eslint-disable-next-line
  }, []);

  const addRatingActivity = (values, cb) => {
    ratingActivityService()
      .addRatingActivity({ratingModelId: ratingId || ratingParamId, ...values})
      .then(() => {
        getRatingActivities();
        setAlertNotification("Action");
        if (cb) {
          cb()
        }
      })
      .catch(err => {
        setAlertNotification("Action", "danger");
      });
  };

  const updateRatingActivity = (values, cb) => {
    ratingActivityService()
      .updateRatingActivity({ratingModelId: ratingId || ratingParamId, ...values})
      .then(() => {
        getRatingActivities();
        setAlertNotification("Action");
        if (cb) {
          cb()
        }
      })
      .catch(err => {
        setAlertNotification("Action", "danger");
      });
  };

  const onSubmit = (values, cb) => {
    if (values.id) {
      updateRatingActivity(values, cb)
    } else {
      addRatingActivity(values, cb)
    }
  };

  return {
    ratingActivities,
    paginationRatingActivities: pagination,
    ratingId: ratingParamId,
    getRatingActivities,
    addRatingActivity,
    onSubmit
  }
};
